export const COOKIE_NAME = 'x-preferred-region-code'
export const QUERY_PARAMETER_FOR_REGION_PREFERENCE = 'setPreferredRegion'
